export const list = state => state.list;
export const more = state => state.more;
export const actionMail = state => state.actionMail;
export const status = state => state.status;
export const reminders = state => state.reminders;
